/* eslint-disable */

// Slick sliders

$(document).ready(function() {
    $('.account-slider').slick({
        dots: true,
        arrows: true,
        adaptiveHeight: false,
        dots: true,
        slidesToShow: 1,
        fade: false,
        infinite: false,
        mobileFirst:true,
        appendDots: '.account-slider-nav',
        prevArrow: '.account-slider-left',
        nextArrow: '.account-slider-right',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true
                }
            },
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            }
        ]
    });

    $('.regime-slider.am').slick({
        dots: true,
        arrows: true,
        adaptiveHeight: false,
        slidesToShow: 1,
        fade: false,
        infinite: false,
        mobileFirst:true,
        appendDots: '.regime-slider-nav-wrap.am .regime-slider-nav',
        prevArrow: '.regime-slider-nav-wrap.am .regime-slider-left',
        nextArrow: '.regime-slider-nav-wrap.am .regime-slider-right',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true
                }
            },
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            }
        ]
    });

    $('.regime-slider.pm').slick({
        dots: true,
        arrows: true,
        adaptiveHeight: false,
        slidesToShow: 1,
        fade: false,
        infinite: false,
        mobileFirst:true,
        appendDots: '.regime-slider-nav-wrap.pm .regime-slider-nav',
        prevArrow: '.regime-slider-nav-wrap.pm .regime-slider-left',
        nextArrow: '.regime-slider-nav-wrap.pm .regime-slider-right',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true
                }
            },
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            }
        ]
    });

    // Reviews slider FACE DR
    $('.reviews-slider').slick({
        centerMode: false,
        centerPadding: '60px',
        dots: false,
        arrows: false,
        adaptiveHeight: false,
        slidesToShow: 3,
        fade: false,
        infinite: false,
        autoplay:false,
        responsive: [
            {
            breakpoint: 1300,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true
            }
          }
        ]
    });

    $('.steps-slider').slick({
        dots: false,
        arrows: false,
        slidesToShow: 3,
        infinite: false,
        responsive: [
            {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                autoplay: true,
                autoplaySpeed: 3000,
                infinite: true
            }
          }
        ]
    });


    $('.reviews-slider .slick-prev').on('click', function() {
        $('.reviews-slider').slick('slickPrev');
    });
    $('.reviews-slider .slick-next').on('click', function() {
        $('.reviews-slider').slick('slickNext');
    });

    var expertSlider = $('.expert-slider');
    if (expertSlider.length > 0) {

        /* expertSlider.on('init', function(event, slick) {
            $('.expert-slider .slick-dots').removeAttr('role');
        }); */

        expertSlider.slick({
            dots: true,
            arrows: true,
            adaptiveHeight: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            cssEase: 'linear',
            fade: true,
            infinite: false,
            customPaging : function(slider, i) {
                var thumb = $(slider.$slides[i]).data();
                var slidenum = thumb.slickIndex + 1;
                return '<a class="dot">'+slidenum+'</a>';
            },
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true
                    }
                }
            ]
        });

        $('.expert-slider .slick-prev').on('click', function() {
            $('.expert-slider').slick('slickPrev');
        });
        $('.expert-slider .slick-next').on('click', function() {
            $('.expert-slider').slick('slickNext');
        });
    }

    // Featured products slider
    $('.featured-product-slider').slick({
        slidesToShow: 3,
        centerMode: false,
        dots: false,
        arrows: false,

        responsive: [
        {
            breakpoint: 1024,
            settings: {
            slidesToShow: 1,
            dots: true
            }
        }
        ]
    });

    // Header slider
    $('.header-slider').slick({
        slidesToShow: 1,
        centerMode: false,
        dots: true,
        arrows: false,
        autoplay: true,
        responsive: [
        {
            breakpoint: 1024,
            settings: {
            dots: true
            }
        }
        ]
    });

    // Restock Slider
    $('.restock-slider').slick({
        dots: true,
        arrows: false,
        adaptiveHeight: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: false,
        infinite: true,
        mobileFirst:true,
        responsive: [
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true
                }
            },
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 2,
                    dots: true
                }
            }
        ]
    });

    // Homepage Hero Slider
    $('.home-hero-slider').slick({
      dots: false,
      arrows: false,
      autoplay: true,
      infinite: true,
      mobileFirst: true
    });



    $('.results-slider').slick({
      infinite: true,
      speed: 180,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: false,
      swipe: true,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
          }
        },
        {
          breakpoint: 856,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            centerMode: true,
            centerPadding: '0',
          }
        },
      ]
    });
    $('.usps-slider').slick({
      infinite: true,
      fade: true,
      speed: 1000,
      cssEase: 'ease-in-out',
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: false,
      dots: false,
      dotsClass: 'slick-dots',
      arrows: true,
      accessibility: true,
      prevArrow: "<button type='button' class='slick-prev'><svg width='20' height='20' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M5 7.5l5 5 5-5' stroke='#243E52' stroke-width='.833' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
      nextArrow: "<button type='button' class='slick-next'><svg width='20' height='20' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M5 7.5l5 5 5-5' stroke='#243E52' stroke-width='.833' stroke-linecap='round' stroke-linejoin='round'/></svg></button>"
    });
    $('.regime-steps-slider').slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      swipe: true,
      swipeToSlide: true,
      draggable: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true
          }
        }
      ]
    });

    // generic slider - needs to be called last
    $('[data-product-slider]').slick({
      dots: true,
      arrows: false
    });

    // $('.product-slider').slick({
    //   autoplay: false,
    //   speed: 180,
    //   dots: true,
    //   arrows: false,
    //   infinite: false,
    //   slidesToShow: 5,
    //   slidesToScroll: 5,
    //   draggable: true,
    //   swipeToSlide: true,
    //   touchMove: true,
    //   autoplay: false,
    //   autoplaySpeed: 3000,
    //   initialSlide: 0,
    //   responsive: [
    //     {
    //       breakpoint: 513,
    //       settings: {
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //       }
    //     },
    //     {
    //       breakpoint: 768,
    //       settings: {
    //         slidesToShow: 2,
    //         slidesToScroll: 2,
    //       }
    //     },
    //     {
    //       breakpoint: 1024,
    //       settings: {
    //         slidesToShow: 2,
    //         slidesToScroll: 2,
    //       }
    //     },
    //     {
    //       breakpoint: 1185,
    //       settings: {
    //         slidesToShow: 3,
    //         slidesToScroll: 3,
    //       }
    //     },
    //     {
    //       breakpoint: 1280,
    //       settings: {
    //         slidesToShow: 4,
    //         slidesToScroll: 4,
    //       }
    //     }
    //   ]
    // });

}); // end doc ready